import { Fade, Stack, Typography, styled } from "@mui/material";
import BizLogo from "./BizLogo";
import { useEffect, useRef, useState } from "react";
import CircleLoader from "./Animation/CircleLoader";
import { useCropperStore } from "../store/cropper/cropper-store";

const timeout = 500;

const FullSizeStack = styled(Stack, {
  name: 'SplashScreen',
  slot: 'root',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  color: 'black',
  placeContent: 'center',
  placeItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#f3f3f3',
}));

function SplashScreen() {
  const isCropperReady = useCropperStore(state => state.isCropperReady());
  const [isShown, setIsShown] = useState(!isCropperReady);
  const delayID = useRef();

  useEffect(() => {
    // clear the timeout (maybe running)
    clearTimeout(delayID.current);
    (async () => {
      await new Promise((resolve) => {
        if (!isCropperReady) {
          resolve();
        } else { 
          delayID.current = setTimeout(resolve, timeout);
        }
      });
      setIsShown(!isCropperReady);
    })();
    return () => clearTimeout(delayID.current);
  }, [isCropperReady]);

  return (
    <Fade in={isShown}>
      <FullSizeStack>
        <BizLogo sx={{ my: 0 }} />
        <Stack direction={`column`} mt={2} alignItems={'center'} justifyContent={'center'}>
          <Typography mb={2}>Stiamo preparando la stampa</Typography>
          <CircleLoader sx={{ color: theme => theme.palette.primary.main }} />
        </Stack>
      </FullSizeStack>
    </Fade>
  );
};

export default SplashScreen;